import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import PropTypes from 'prop-types';

import {styles, colors} from '../../lib/styles';

const DefaultButton = (props) => {
    const {
        label,
        onClick,
        disabled
    } = props;

    return (
        <RaisedButton
            disabled={disabled}
            label={label}
            style={styles.sidebar.button}
            backgroundColor={colors.button}
            labelColor='#fff'
            labelStyle={{fontWeight: 'normal'}}
            onClick={() => {
                onClick();
            }}
        />
    )
};

DefaultButton.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
};
DefaultButton.defaultProps = {
    label: 'Сохранить',
    disabled: false
};

export {DefaultButton};



// WEBPACK FOOTER //
// src/components/controls/button.js